export function textToInitials(text = '', options = {}) {
  const { maxWords = Infinity, keepSymbolInitials = false } = options;

  return text
    .split(' ')
    .filter(word => word.length > 0)
    .filter(word => keepSymbolInitials || /[A-Za-z0-9]/.test(word[0]))
    .slice(0, maxWords)
    .map(word => word[0])
    .join('');
}
